export default __webpack_public_path__ + "static/media/Shell5.43fb18da.mp4";